<template>
  <div class="bao-ming-open" v-if="baoMingOpen">
    <div class="bao-ming-container">
      <div class="bao-ming-text">
        <div>
          <div class="bao-ming-title">{{ $dt(menuInfo, 'signTitle') }}</div>
          <div class="bao-ming-desc">{{ $dt(menuInfo, 'signRemark') }}</div>
        </div>
        <img v-if="menuInfo.signImage" class="bao-ming-img" :src="$Dolphin.path.publicPath + menuInfo.signImage?.filePath"/>
      </div>
      <div class="bao-ming-close" @click="closeBaoMing">×</div>
    </div>
  </div>
  <div class="bao-ming-close-btn" v-else @click="openBaoMing">
    {{ $t('招生报名') }}
  </div>
</template>
<script>
export default {
  name: "signBar",
  props: {
    menuInfo: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      baoMingOpen: true,
    };
  },
  methods: {
    closeBaoMing() {
      this.baoMingOpen = false;
    },
    openBaoMing() {
      this.baoMingOpen = true;
    }
  },
}
</script>

<style scoped lang="scss">

.bao-ming-open {
  height: 126px;
  position: fixed;
  left: 50%;
  bottom: 0;
  z-index: 1000;
  width: 1440px;
  transform: translateX(-50%);
  background-image: url("../../../public/static/indexUse/baomingbg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  //box-shadow: 0 -3px 8px rgba(0, 0, 0, 0.06);

  &::before {
    content: '';
    position: absolute;
    left: -400px;
    right: 99%;
    top: 21px;
    bottom: 0;
    background: #013c82;
    border-top: 4px solid #4983bd;
  }

  &::after {
    content: '';
    position: absolute;
    left: 99%;
    right: -400px;
    top: 21px;
    bottom: 0;
    background: #013c82;
    border-top: 4px solid #4983bd;
  }

  .bao-ming-container {
    width: 1280px;
    margin: 0 auto;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    .bao-ming-text {
      margin-left: 40px;
      color: #fff;
      display: flex;
      align-items: center;

      .bao-ming-title {
        text-align: center;
        font-size: 22px;
        font-weight: bold;
        line-height: 1.4;
      }

      .bao-ming-desc {
        text-align: center;
        font-size: 13px;
        line-height: 1.4;
        opacity: 0.9;
        margin-top: 2px;
      }

      .bao-ming-img {
        width: 60px;
        height: 60px;
        margin-left: 20px;
      }
    }

    .bao-ming-close {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      font-size: 24px;
      color: #fff;
      cursor: pointer;
      line-height: 1;
      transition: opacity 0.3s ease;

      &:hover {
        opacity: 0.7;
      }
    }
  }
}

.bao-ming-close-btn {
  position: fixed;
  bottom: 0;
  right: 24px;
  width: 120px;
  height: 48px;
  line-height: 48px;
  text-align: center;
  background: #D93379;
  color: #fff;
  font-weight: bold;
  border-radius: 8px 8px 0 0;
  cursor: pointer;
  z-index: 1000;
  //box-shadow: 0 4px 12px rgba(0, 60, 130, 0.3);
  transition: all 0.3s ease;

  //&:hover {
  //  background: #002f68;
  //  transform: translateY(-2px);
  //}
}
</style>
